import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useLocalizedNavigate } from '../../hooks/useLocalizedNavigate'

export default function PaymentCancel() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()

  useEffect(() => { document.title = `${t('payment.cancelTitle')} | ${t('common.appName')}` }, [t])

  return (
    <div className="container">
      <div className="card text-center" style={{ maxWidth: '500px', margin: '3rem auto' }} role="status">
        <FontAwesomeIcon
          icon="xmark"
          style={{ fontSize: '3rem', color: 'var(--gray-500)', marginBottom: '1rem' }}
        />
        <h1>{t('payment.cancelTitle')}</h1>
        <p className="text-gray mb-4">{t('payment.cancelMessage')}</p>

        <div className="flex gap-2 justify-center">
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            {t('payment.goHome')}
          </button>
          <button className="btn btn-outline" onClick={() => navigate('/pricing')}>
            {t('payment.viewPricing')}
          </button>
        </div>
      </div>
    </div>
  )
}
